import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-client-share-review-link',
  templateUrl: './client-share-review-link.component.html',
  styleUrls: ['./client-share-review-link.component.scss']
})
export class ClientShareReviewLinkComponent implements OnInit {
  shareClientId: string;
  userData: any;
  reviewList: any;
  showTxt:any = "Show More";
  reviewObj:any;
  reviewId:any = null;
  descriptionText:any = "";
  counter:any = 100;
  firstCount:any = 100;
  last_index:any = 100;
  showFullDescription: { [index: number]: boolean } = {};
  gfbid: any;
  is_paid: any;
  feedbackmessagesObj: any;
  is_paid_message: string;
  getallname: any;
  enteredPass: any;
  superAdminCode = '1111';
  private modalRef;
  imgUrl = environment.ImageUrl;
  imagepreview: any;
  is_client_side_paid: any;
  showFullClientRemarks: { [index: number]: boolean } = {};
  clientRemarksText: any;
  showFullUserRemarks: { [index: number]: boolean } = {};
  userRemarksText: any;
  purchasedSlots: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
  ) {
    route.queryParams.subscribe(val => {
      // console.log(val,'---val----');
      this.shareClientId = atob(val.c)
      // console.log(this.shareClientId,'---this.sharePhone----');
      // this.getReviewList(this.shareClientId)
      if(val.hasOwnProperty("status")) {
        if(val.status == "complete") {
          Swal.fire(
            'Success',
            'Payment has been successfully processed, and the slots have been credited to your account.',
            'success'
          ).then(() => {
            window.location.href = window.location.href.split("&status")[0];
          });
        }
        if(val.status == "expired") {
          Swal.fire(
            'Expired',
            'The payment link has expired. Kindly choose the slots from the dropdown once more to complete the purchase.',
            'warning'
          ).then(() => {
            window.location.href = window.location.href.split("&status")[0];
          });
        }
        if(val.status == "error") {
          Swal.fire(
            'Error',
            'Something went wrong.',
            'error'
          ).then(() => {
            window.location.href = window.location.href.split("&status")[0];
          });
        }
      }
    });
   }

  ngOnInit(): void {
    this.getReviewList(this.shareClientId)
  }

  getReviewList(clientId){
    this.auth.getClientShareReview(clientId).subscribe(
      (response: any) => {
        // console.log(response.body,'----response---')
        const currentTime = Math.round(new Date().getTime() / 1000)
        const responseData = response.body;
        this.userData = responseData?.userData;
        this.reviewList = responseData?.reviewData;
        this.purchasedSlots = responseData?.slotArray;
        // console.log(this.reviewList,'---this.reviewList---');
        
       return responseData;
      },
      (error) => {
        // console.log(error,'----error---')
      }
    );
  }

  toggleDescription(index: number, review) {
    this.showFullDescription[index] = !this.showFullDescription[index];
    this.descriptionText = review?.feedback_google?.description
  }

  toggleClientRemarks(index: number, review) {
    this.showFullClientRemarks[index] = !this.showFullClientRemarks[index];
    this.clientRemarksText = review?.feedback_google?.client_remarks
  }
  
  toggleUserRemarks(index: number, review) {
    this.showFullUserRemarks[index] = !this.showFullUserRemarks[index];
    this.userRemarksText = review?.feedback_google?.user_remarks
  }

  saveFeedbackPayment(content, gfbid, is_client_side_paid, feedbackmessagesObj, type) {
    this.gfbid = gfbid
    this.is_client_side_paid = is_client_side_paid
    this.feedbackmessagesObj = feedbackmessagesObj
    // console.log(this.feedbackmessagesObj,'----this.feedbackmessagesObj---');
    
    this.is_paid_message = is_client_side_paid == 1 ? 'Approve?' : 'Dis-approve?'
    if(type == 1){
      this.modalService.open(content, { size: 'sm' });
    } else if(type == 2) {
      this.onPaymentApprove(content, gfbid, is_client_side_paid, feedbackmessagesObj, type)
    } else{
      // let nameData = this.getallname.filter(data => data.phno == feedbackmessagesObj.phone && data.name == feedbackmessagesObj.name )
      // nameData = nameData.length > 0 ? nameData[0] : {}
      // console.log(nameData,'----nameData-------');
      // return
      const saveObj = {
        gfbid,
        is_paid: is_client_side_paid,
        feedback_msg_id: feedbackmessagesObj.id
      }

      // console.log(saveObj,'---saveObj---');
      
      // return
      // this.onPaymentApprove(content, gfbid, is_paid, feedbackmessagesObj, type)
      // update approval

      if(feedbackmessagesObj?.manual_type == 1){
        this.auth.saveFeedbackPaymentClient(saveObj).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            this.ngOnInit();
            this.modalService.dismissAll();
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }

      if(feedbackmessagesObj?.manual_type == 2){
        this.auth.saveFeedbackPaymentClient_2(saveObj).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            this.ngOnInit();
            this.modalService.dismissAll();
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }
      if(feedbackmessagesObj?.manual_type == 3){
        this.auth.saveFeedbackPaymentClient_3(saveObj).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            this.ngOnInit();
            this.modalService.dismissAll();
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }

    }
  }

  otp_modal(modal:any, form_id, action) {
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    // this.gfbid = form_id;
    // this.actionText = action;
    // this.is_paid_message = action;
  }

  onOtpChange(event) { this.enteredPass = event; }

  onPaymentApprove(content, gfbid, is_client_side_paid, feedbackmessagesObj, type) {
    // console.log(action,'--------------------------------------------action')
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter correct password')
      return;
    }
    if((this.enteredPass) === this.superAdminCode) {
      this.saveFeedbackPayment(content, gfbid, is_client_side_paid, feedbackmessagesObj, 3)
    } else {
      this.toastr.error('Password is incorrect');
      return
    }

  }

  viewImage(content: string, data) {
    this.imagepreview = data?.feedback_google ? data?.feedback_google?.image : data?.feedback_google_two ? data?.feedback_google_two?.image : data?.feedback_google_three ? data?.feedback_google_three?.image : ''
    this.modalService.open(content, { size: 'sm', backdrop: 'static' });
    // this.verify_review(id)

  }

  clientUrlPayment(event) {
    const selectedSlot = event.target.value;
    const slot_price_ids = {
      // LOCAL

      // "10": {
      //   amount: "7",
      //   price_id: "price_1OEEnhJSfPyvcn3Rw7NQ4TOh",
      //   slots: "10"
      // },
      // "30": {
      //   amount: "6.5",
      //   price_id: "price_1OEEnGJSfPyvcn3RU0gJsYEL",
      //   slots: "30"
      // }

      // LIVE

      "10": {
        amount: "70",
        price_id: "price_1OK242JSfPyvcn3RekvY5yfN", // 10_30_SLOTS
        slots: "10"
      },
      "30": {
        amount: "210",
        price_id: "price_1OK24eJSfPyvcn3RKoR9F5sc", // 10_30_SLOTS
        slots: "30"
      }
    };
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to purchase ${slot_price_ids[selectedSlot].slots} slots`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if(result.isConfirmed) {
        const amount = slot_price_ids[selectedSlot].amount; 
        const stripe_price_id = slot_price_ids[selectedSlot].price_id;
        let formData = new FormData();
        formData.append("client_id", this.shareClientId);
        formData.append("slot", selectedSlot);
        formData.append("amount", amount);
        formData.append("stripe_price_id", stripe_price_id);
        this.auth.clientUrlPayment(formData).subscribe(
          (response: any) => {
            // console.log(response)
            window.location.href = response.body.url;
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
          }
        );
      }
    });
  }

  update_circle_client(id, manual_type) {
    this.auth
      .update_circle_client_url({manual_type}, id)
      .subscribe(
        (response: any) => {
          // this.toastr.success(response.message);
          this.ngOnInit();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  openClientTextPopup() {
    Swal.fire({
      title: "NOTES",
      input: "textarea",
      inputValue: `${this.userData?.clientText}`,
      showCancelButton: true,
      confirmButtonText: "OK"
    }).then(result => {
      if(result.isConfirmed) {
        this.updateClientText(result.value);
      }
    });
  }

  updateClientText(value) {
    let formData = new FormData();
    formData.append("clientId", this.shareClientId);
    formData.append("clientText", value);
    this.auth.updateClientText(formData).subscribe(
      (response: any) => {
        console.log(response)
        this.userData.clientText = value;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

}
